import Tabs from '@mui/material/Tabs'

import {
    SyntheticEvent,
} from 'react'

import LinkTab from './LinkTab'
import useStyles from './SkyNetTabs.styles'

export type SkyNetTab = {
    name: string;
}
const SkyNetTabs = ({
    tabs,
    value,
    onChange,
}: Readonly<{
    tabs: SkyNetTab[]
    value: number,
    onChange: (value: number) => void,
}>) => {
    const {
        classes,
    } = useStyles()

    const handleChange = (_event: SyntheticEvent, newValue: number) => {
        onChange(newValue)
    }

    return (
        <Tabs
            value={value}
            onChange={handleChange}
            role="navigation"
            className={classes.tabs}
        >
            {tabs?.map((tab, i) => {
                return (
                    <LinkTab
                        key={`tab-${i}`} // eslint-disable-line react/no-array-index-key
                        label={tab.name}
                        selected={value === i}
                    />
                )
            })}
        </Tabs>
    )
}

export default SkyNetTabs
